import TileSprite from './tileSprite'

export default class Laser extends TileSprite {
  constructor (game, x, y, key, frame) {
    super(game, x, y, key, frame)
    this.setupAnimation()

    this.beams = []
  }

  registerValues (objectValues) {
    super.registerValues(objectValues)

    this.values.on = objectValues.next(0x00ff00)
    this.values.on.set(this.on)
    this.values.on.watch((value) => { this.on = (value > 0) })
  }

  setupAnimation () {
    const states = ['on', 'off']
    const directions = ['left', 'right', 'down', 'up']

    states.forEach((state) => {
      directions.forEach((direction) => {
        const animation = `${state}-${direction}`
        this.animations.add(animation, [`laser-${animation}`], 0, false)
      })
    })
  }

  update () {
    const state = this.on ? 'on' : 'off'
    this.play(`${state}-${this.direction}`)
  }

  canMove (tileMap, entities, x_dest, y_dest) {
    const targetTile = tileMap.getTile(x_dest, y_dest, 'tiles')

    if (!targetTile || targetTile.properties.collidable) {
      return false
    }

    for (let ent of entities) {
      if (ent.collidable && ent.tileX === x_dest && ent.tileY === y_dest) {
        return false
      }
    }

    return true
  }

  updateBeams (tileMap, entities) {
    this.clearBeams()

    if (this.on) {
      let x_direction = 0
      let y_direction = 0

      switch (this.direction) {
        case ('left'):
          x_direction = -1
          break
        case ('right'):
          x_direction = 1
          break
        case ('down'):
          y_direction = 1
          break
        case ('up'):
          y_direction = -1
          break
      }

      let check_next = true
      let x_dest = this.tileX
      let y_dest = this.tileY

      while (check_next) {
        x_dest += x_direction
        y_dest += y_direction

        if (this.canMove(tileMap, entities, x_dest, y_dest)) {
          this.addBeam(x_dest, y_dest)
        } else {
          check_next = false
        }
      }
    }
  }

  clearBeams () {
    this.beams.forEach((beam) => {
      beam.destroy()
    })

    this.beams = []
  }

  wouldCollide (tileXDest, tileYDest) {
    for (let beam of this.beams) {
      const beamTileX = this.tileX + beam.tileX
      const beamTileY = this.tileY + beam.tileY

      if (beamTileX === tileXDest && beamTileY === tileYDest) {
        return true
      }
    }

    return super.wouldCollide(tileXDest, tileYDest)
  }

  addBeam (x, y) {
    const beamXTile = x - this.tileX
    const beamYTile = y - this.tileY

    const direction = this.direction === 'down' || this.direction === 'up' ? 'vertical' : 'horizontal'

    const beam = new TileSprite(
      this.game, beamXTile * TILE_WIDTH, beamYTile * TILE_HEIGHT,
      'sloth', `laser-beam-${direction}`
    )

    this.addChild(beam)
    this.beams.push(beam)
  }
}
